import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-popup',
  template: `
    <div class="popup-container" (click)="onBackdropClick($event)">
      <img [src]="'data:' + (data.imageMimeType || 'image/jpeg') + ';base64,' + data.image" alt="Zoomed In Image" class="popup-image"/>
      <button class="close-button" (click)="onCloseClick($event)">X</button>
    </div>
  `,
  styles: [`
    .popup-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.8);
      z-index: 9999;
      padding: 20px;
    }

    .popup-image {
      width: 100vw;
      height: 100vh;
      object-fit: contain;
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      background: rgba(255, 255, 255, 0.6);
      border: none;
      font-size: 24px;
      color: black;
      padding: 5px;
      cursor: pointer;
      border-radius: 50%;
      transition: background 0.3s ease;
    }
  `]
})
export class ImagePopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ImagePopupComponent>
  ) { }

  onBackdropClick(event: Event): void {
    event.stopPropagation();  // Prevent click event propagation
    this.dialogRef.close();   // Close the dialog when clicking on the backdrop
  }

  onCloseClick(event: Event): void {
    event.stopPropagation();  // Prevent click event propagation
    this.dialogRef.close();   // Close the dialog when clicking the close button
  }
}
